import { styled } from '@mui/material/styles';
import Dialog, { DialogProps } from '@mui/material/Dialog';

export const Popup = styled(Dialog)<DialogProps>(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));
